import React, { useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { invokeAction } from '../../../lib/globalActions'
import StatefulCardImage from '../../Srp/CardCarousel'
import CardContent from '../CardContent'

const ListingCard = ({
  listing,
  removeMarkAsActive,
  onSave,
  hideOutline,
  fixedWidth,
  wrapperCalssName,
  isEagerLoad= false
}) => {
  const wrapperRef = useRef(null)

  const handleMouseHover = useCallback(id => () => {
    invokeAction('SearchResultsMapDesktop', 'setHoveredListingId', id)
  }, [listing])

  const handleDoubleClick = e => {
    e.stopPropagation()
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        removeMarkAsActive()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [removeMarkAsActive])

  return (
    <li
      className={cn('ListingCard', wrapperCalssName, { 'ListingCard--width300px': fixedWidth })}
      data-track_click={listing.trackingLabel}
      data-track_imp={listing.trackingLabel}
      data-track_featured_click={listing.trackingFeaturedLabel}
      data-track_featured_imp={listing.trackingFeaturedLabel}
      onMouseEnter={handleMouseHover(listing.id)}
      onMouseLeave={handleMouseHover(null)}
    >
      <div className={cn('ListingCard-wrapper', { 'ListingCard-wrapper--noOutline': hideOutline})}>
        <a href={listing.links.self} className='ListingCard-link' onDoubleClick={handleDoubleClick} ref={wrapperRef}>
          <StatefulCardImage
            containsVideoTour={listing.isVideoTour}
            containsZillow3dTour={listing.isZillow3dTour}
            closestOpenHouseDate={listing.openHouseDateDisplay}
            closestOpenHouseTime={listing.openHouseTimeDisplay}
            isRecent={listing.isRecent}
            isActive={listing.active}
            status={listing.statusDisplay}
            initialPhoto={listing.initialCardPhotos}
            listingId={listing.id}
            highlights={listing.highlights}
            listingClass={listing.listingClass}
            isEagerLoad={isEagerLoad}
          />
          <CardContent
            address={listing.address}
            undisclosedAddressText='(Undisclosed Address)'
            saved={listing.saved}
            id={listing.id}
            townName={listing.townName}
            price={listing.priceDisplay}
            currentPricePeriodLabel={listing.periodDisplay}
            land={listing.isLand}
            beds={listing.bedsDisplay}
            bathsDisplay={listing.bathsDisplay}
            acreage={listing.acreageDisplay}
            sqft={listing.sqftDisplay}
            byOwner={listing.isByOwner}
            listingBy={listing.brokerageNameDisplay}
            isActive={listing.active}
            listingClass={listing.listingClass}
            onSave={onSave}
          />
        </a>
      </div>
    </li>
  )
}

ListingCard.propTypes = {
  hideOutline: PropTypes.bool,
  listing: PropTypes.object,
  removeMarkAsActive: PropTypes.func,
  onSave: PropTypes.func,
  fixedWidth: PropTypes.bool,
  wrapperCalssName: PropTypes.string,
  isEagerLoad: PropTypes.bool
}

ListingCard.defaultProps = {
  removeMarkAsActive: () => {},
  hideOutline: false,
  fixedWidth: false,
  wrapperCalssName: ''
}

export default ListingCard
